import React from 'react'
import { Link } from 'react-router-dom'

import MetadataLabel from './MetadataLabel'
import * as dateLib from '../../../libraries/date'
import ContentTag from './ContentTag'
import AuthorsLabel from './AuthorsLabel'
import ClickableCard from '../layout/ClickableCard'
import PlayCircle from '../../../assets/icons/play-circle.svg?react'
import ProgressBar from './VideoProgressBar'
import BookmarkButton from './BookmarkButton'
import VideoCardPreviewMedia from './VideoCardPreviewMedia'

type Props = {
  id: number,
  title: string,
  image?: string,
  previewUrl?: string,
  authors: Array<string>,
  duration: number,
  viewersCount?: number,
  type: { name: string, color: string },
  difficulty: string,
  category: string,
  watched?: boolean,
  currentPlayTime?: number,
  bookmarked?: boolean
}
const VideoCard: React.FC<Props> = ({ id, title, image, previewUrl, authors, duration, viewersCount = 0, type, difficulty, category, watched, currentPlayTime, bookmarked }) => {
  const [cardHovered, setCardHovered] = React.useState(false)

  return (
    <ClickableCard>
      <div className='h-full'>
        <Link
          to={`/content/videos/${id}`}
          className='flex sm:block relative h-full'
          onMouseEnter={() => setCardHovered(true)}
          onMouseLeave={() => setCardHovered(false)}
        >
          <div className='pointer-events-none z-10 absolute w-28 sm:w-auto sm:flex flex-col items-center justify-end p-1 sm:p-4 top-1 sm:end-0 text-center sm:top-1 sm:end-0 text-white font-light'>
            <div className='text-sm sm:text-4xl border-b border-b-white border-solid pb-0 sm:pb-1 mb-1 sm:mb-2'>{type.name}</div>
            <div className='text-xs sm:text-2xl'>{difficulty}</div>
            <div className='sm:self-end mt-8 -translate-x-[1vw]'><PlayCircle className='fill-white w-9 h-9 sm:w-full sm:h-full block mx-auto' /></div>
          </div>
          <div className='relative'>
            <VideoCardPreviewMedia
              alt={title}
              posterSrc={image}
              previewSrcUrl={previewUrl}
              cardHovered={cardHovered}
              className='w-36 sm:w-full h-full sm:h-56 rounded-s-lg sm:rounded-b-none sm:rounded-t-lg object-cover'
            />
            <ProgressBar duration={duration} watched={watched} currentPlayTime={currentPlayTime} />
          </div>
          <div className='p-2 sm:p-3 w-full inline-block'>
            <div className='flex items-center justify-between'>
              <p className='h-12 line-clamp-2 text-black text-xs sm:text-sm font-semibold'>{title}</p>
              {bookmarked && <div className='-translate-y-2'><BookmarkButton bookmarked onClick={() => {}} /></div>}
            </div>
            <div className='text-gray-600 text-xs mt-2 font-light'>
              <div className='h-10'>
                <AuthorsLabel authors={authors} />
              </div>
              <div className='text-2xs sm:text-xs flex mt-2 sm:gap-x-3 flex justify-between'>
                <div className='flex gap-x-2'>
                  <MetadataLabel icon='clock'>{dateLib.parseSecondsToHoursAndMinutes(duration)}</MetadataLabel>
                  {viewersCount > 0 ? <MetadataLabel icon='play'>{viewersCount}</MetadataLabel> : null}
                </div>
                <ContentTag label={category} bgColor='soft-green' textColor='deep-green' />
              </div>
            </div>
          </div>
        </Link>
      </div>
    </ClickableCard>
  )
}

export default VideoCard
